import type { IconName } from '@helsenorge/designsystem-react/components/Icons/IconNames';

const ikonMap: Record<string, IconName> = {
  FY01: 'ElderlyPerson',
  FY02: 'FirstAidKit',
  FY03: 'PersonInXRayMachine',
  FY04: 'Breasts',
  FY05: 'DigestiveSystem',
  FY06: 'MaleDoctor',
  FY07: 'Pregnant',
  FY08: 'Heart',
  FY09: 'Hormone',
  FY10: 'Skin',
  FY11: 'PersonWithJaw',
  FY12: 'Female',
  FY13: 'MaleGenitalia',
  FY14: 'ArmFlexing',
  FY15: 'MuscleLeg',
  FY16: 'MuscleBack',
  FY17: 'PersonWithBrain',
  FY18: 'Kidney',
  FY19: 'JointPain',
  FY20: 'BandAid',
  FY21: 'MaleDoctorAndPerson',
  FY22: 'EarNoseThroat',
  FY23: 'Eye',
  FY24: 'Lungs',
  FY25: 'TeddyBear',
  RE01: 'Skeleton',
  RE02: 'JointPain',
  RE03: 'Amputation',
  RE04: 'PersonRelaxing',
  RE05: 'Cancer',
  RE06: 'Brain',
  RE07: 'PersonWithBrain',
  RE08: 'Heart',
  RE09: 'Lungs',
  RE10: 'ArmFlexing',
  RE11: 'PersonOverweight',
  RE12: 'PersonWithSenses',
  RE13: 'Hiker',
  RE14: 'PersonWorking',
  RE15: 'Puzzle',
  RE16: 'Hormone',
  REHAB: 'PersonWorking',
  REHA: 'PersonWorking',
  HABU: 'ChildPlaying',
  HAVO: 'PersonWithCrutches',
  TSB: 'BeerAndPills',
  VOP: 'MentalHealthAdult',
  BUP: 'MentalHealthChild',
};

export const behandlingSvgIkonMapper = (kode: string | null): IconName => (kode && ikonMap[kode] ? ikonMap[kode] : ('Minus' as IconName));
